module.exports = __webpack_public_path__ + "static/media/folder.e217b93f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/folder.svg
// module id = 1328
// module chunks = 0